import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MuiSelect from '@material-ui/core/Select';
import ErrorMessage from '../ErrorMessage';

export default function Select(props) {
  const { errors } = props;
  const hasErrors = errors && errors.length > 0;
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);

  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <FormControl
      required={props.required}
      error={hasErrors}
      variant={props.variant}
      fullWidth={props.fullWidth}
      disabled={props.disabled}
      margin='normal'
    >
      <InputLabel ref={inputLabel}>{props.label}</InputLabel>
      <MuiSelect
        name={props.name}
        value={props.value || ''}
        onChange={props.onChange}
        labelWidth={labelWidth}
      >
        {props.options.map((o) => (
          <MenuItem key={o[props.valueKey]} value={o[props.valueKey]}>
            {props.getLabel ? props.getLabel(o) : o[props.labelKey]}
          </MenuItem>
        ))}
      </MuiSelect>
      {hasErrors ? (
        <FormHelperText>
          <ErrorMessage errors={errors} />
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

Select.defaultProps = {
  valueKey: 'id',
  labelKey: 'label',
};
